<template>
  <div class="depo-progress_dep">
    <el-dialog
      @close="onClose"
      :visible.sync="popupVisible">

      <div class="dep_wrap">

        <div class="dep_title">
          <div class="dep_title_img-wrap" :style="{ height: `${perc}%` }">
          <div
            class="dep_title_img"></div>
          </div>
          <div class="dep_title_perc">{{ perc }}%</div>
          <div class="dep_title_text">Размещение объекта</div>
        </div>

        <template v-if="task && task.Progress">
          <div
            class="dep_step"
            v-for="(group, groupI) in task.Progress.Groups"
            :class="{ [`dep_step-${groupI}`]: true,
              'has-error': task.Messages }"
            :key="`group-${groupI}`">
            <div class="dep_step_title">{{ group.Title }}</div>
            <div
              v-for="(step, stepI) in group.Steps"
              :key="`step-${groupI}-${stepI}`"
              class="dep_item">
              <div
                class="dep_item_img"
                :class="{ dep_done: step.Complete,
                  'dep_current': stepI > 1 && !step.Complete && group.Steps[stepI - 1].Complete }">
              </div>
              {{ step.Title }}
            </div>
          </div>
        </template>

        <transition name="dep_slide">
        <div
          v-if="task && task.Messages"
          class="dep_errors">
          <div class="dep_error-title">
            Размещение объекта прервано следующими ошибками:</div>
          <div
            v-for="(v, i) in task.Messages"
            :key="`dep-error-${i}`"
            class="dep_error">
            {{ v }}
          </div>
          <div class="dep_error-note">
            Попробуйте разместить объект повторно через 30-60
            минут. Если ошибки сохраняться, пожалуйста,
            свяжитесь с администраторами проекта.
          </div>
        </div>
        </transition>

        <img
          src="/static/grx/stamp.png"
          class="dep_stamp"
          :class="{ 'is-visible': task && task.Progress.Progress === task.Progress.ProgressTotal }">

      </div>

      <span slot="footer" class="dialog-footer buttons-wrap">
        <button class="vivid-button dep_close" @click="closePopup()">
          <template v-if="task && task.Message">Закрыть</template>
          <template v-else>Закрыть и продолжить</template>
        </button>
        <el-tooltip
          class="dep_close-help-icon"
          placement="top"
          :enterable="false"
          :open-delay="300">
          <div slot="content">Закрытие этого окна
            не прерывает<br>процесс размещения объекта.</div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </span>

    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable max-len */
import axios from 'axios';

export default {

  props: {
    taskId: Number,
  },

  data() {
    return {
      task: null,
      refreshTime: 2000,
      refreshTimer: null,
      popupVisible: false,
    };
  },

  created() {
    // axios.get('tests/animateTask');
    this.fetchData();
  },

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },

  computed: {

    perc() {
      if (this.task && this.task.Progress) {
        return Math.ceil((this.task.Progress.Progress / this.task.Progress.ProgressTotal) * 100);
      }
      return 0;
    },

  },

  watch: {

    popupVisible() {
      if (!this.popupVisible) {
        this.$emit('update:taskId', 0);
      }
    },

  },

  methods: {

    fetchData() {
      if (this.taskId) {
        axios.get(`tasks/${this.taskId}`).then((r) => {
          this.task = r.data;
          this.popupVisible = true;
          this.$nextTick(this.$forceUpdate);
          this.refreshTimer = setTimeout(() => {
            if (this.task
              && (this.task.Messages
                || this.task.Progress.Progress === this.task.Progress.ProgressTotal)
            ) {
              clearTimeout(this.refreshTimer);
              return;
            }
            this.fetchData();
          }, this.refreshTime);
        });
      }
    },

    onClose() {
      clearTimeout(this.refreshTimer);
    },

    closePopup() {
      this.popupVisible = false;
    },

  },

};
</script>

<style lang="scss">
.depo-progress_dep {

  .dep_wrap {
    margin: 0;
  }

  .dep_title {
    position: relative;
    height: 89px;
    margin: 0 auto 30px;
    padding: 38px 0 0 100px;
    background: 0 0 no-repeat url('data:image/png;base64,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');
    .dep_title_text {
      font-size: 17px;
      color: #e06792;
      font-weight: bold;
      text-transform: uppercase;
      @media (max-width: 400px) {
        width: 180px;
        margin-top: -12px;
      }
    }
    .dep_title_perc {
      position: absolute;
      top: 36px;
      left: 0;
      width: 81px;
      text-align: center;
      font-size: 19px;
      color: #000;
    }
    .dep_title_img-wrap {
      width: 81px;
      height: 0;
      position: absolute;
      top: 0;
      left: 0;
      transition: height 1s;
      overflow: hidden;
    }
    .dep_title_img {
      width: 81px;
      height: 89px;
      top: 0;
      left: 0;
      position: absolute;
      background: 0 0 no-repeat url('data:image/png;base64,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');
    }
  }

  .dep_step {
    margin: 0 0 20px;
    font-size: 15px;
    color: #000;
    &.dep_step-2 {
      margin-bottom: 30px;
    }
    .dep_step_title {
      font-weight: bold;
      padding-left: 18px;
      line-height: 17px;
      margin-bottom: 5px;
    }
    &.has-error .dep_item_img {
      &.dep_done {
        background-color: #333;
      }
      &.dep_current {
        background-color: #333;
        animation: none;
      }
    }
  }

  .dep_item {
    position: relative;
    padding-left: 18px;
    .dep_item_img {
      position: absolute;
      top: 4px;
      left: 0;
      border-radius: 50%;
      width: 10px;
      height: 10px;
      background-color: #e6e7e9;
      transition: background-color .2s;
      &.dep_done {
        background-color: #f3426c;
      }
      &.dep_current {
        background-color: #f3426c;
        animation: fade 1s infinite;
      }
    }
  }

  @keyframes fade {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }

  .dep_close {
    margin-left: 20px;
  }

  .dep_close-help-icon {
    color: #f95270;
    font-size: 20px;
    position: relative;
    left: 5px;
    top: 2px;
  }

  .dep_stamp {
    display: block;
    margin: 0 auto;
    height: 0;
    transition: height 0.3s;
    &.is-visible {
      height: 78px;
    }
  }

  .dep_errors {
    font-size: 15px;
    .dep_error-title {
      color: #f3426c;
      margin-bottom: 5px;
      font-weight: bold;
    }
    .dep_error {
      color: #f3426c;
      margin-bottom: 3px;
      padding-left: 14px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: 7px;
        left: 0;
        width: 5px;
        height: 5px;
        background-color: #f3426c;
        border-radius: 50%;
      }
    }
    .dep_error-note {
      margin-top: 5px;
      color: #000;
      font-size: 13px;
    }
  }
}
.el-dialog {
  max-width: 500px;
}
.el-dialog__wrapper {
  cursor: default;
}

.dep_slide-enter-active, .dep_slide-leave-active {
  transition: max-height .3s;
  max-height: 999px;
}
.dep_slide-enter, .dep_slide-leave-to {
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DepoProgress.vue